<app-horizontal-widget-bar *ngIf="!isVerticalDisplay"></app-horizontal-widget-bar>
<app-vertical-widget-grid *ngIf="isVerticalDisplay"></app-vertical-widget-grid>
